import styled from 'styled-components'

export const AddLine = styled.div`
  border: 1px dashed #3d3d3d;
  /* margin-top: 12px; */
  /* margin-left: 12px; */
  /* margin-right: 12px; */
  display: flex;
  border-radius: 6px;
  padding: 6px;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background-color: #f0f0f0;
    border-color: #000;
  }
`
